<template>
  <GModal @onclick-backdrop="handleClose">
    <div slot="header"></div>
    <div slot="body">
      <div class="share-experience" :class="{ 'see-all': isSeeAll }">
        <div v-if="!isSeeAll" class="header-banner">
          <h2>Yuk, Tulis Review!</h2>
          <h5>
            Bagikan pengalamanmu dan dapatkan +20 SP
            <br />
            untuk setiap Trusted Review yang kamu bagikan!
          </h5>
        </div>
        <div class="body-wrapper">
          <div v-if="!isSeeAll" class="search-wrapper">
            <div class="input-search-header">
              <input
                v-model="searchKey"
                type="text"
                class="form-control"
                placeholder="What do you want to review"
                autocomplete="off"
              />
            </div>
          </div>
          <h4 v-if="isPopularProducts">Popular Products</h4>
          <h4 v-else>What Do You Love About This?</h4>
          <h5 v-if="isSeeAll">
            Bagikan pengalamanmu dan dapatkan <span>+20 SP</span> untuk setiap review yang kamu bagikan!
          </h5>
          <div class="product-list-wrapper">
            <CardRecentlyBought
              v-for="(product, i) in filteredProductList"
              :key="i"
              :review-data="product"
              inline-footer
              :is-show-rating="isPopularProducts"
              @write-review-clicked="handleClose"
            />
          </div>
        </div>
      </div>
    </div>
  </GModal>
</template>

<script>
import { get, last } from 'lodash';
export default {
  name: 'ModalShareExperience',
  components: {
    CardRecentlyBought: () => import('../../dashboard/snippet/card-recently-bought'),
  },
  data() {
    return {
      searchKey: '',
    };
  },
  computed: {
    filteredProductList() {
      if (this.searchKey.length) {
        const key = new RegExp(this.searchKey, 'i');
        return this.productList.filter((p) => key.test(p.name) || key.test(p.brand.name));
      }
      return this.productList;
    },
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
    productList() {
      let productList = [];
      if (this.$store.state.product && this.$store.state.product.recentlyBought.length) {
        productList = this.$store.state.product.recentlyBought;
      } else {
        productList = this.$store.state.product.trendingProductsPopup;
      }
      return productList;
    },
    isPopularProducts() {
      if (this.$store.state.product && !this.$store.state.product.recentlyBought.length) {
        return true;
      }
      return false;
    },
    isSeeAll() {
      return this.$store.state.modal.isSeeAll;
    },
  },
  watch: {
    isDesktop: {
      handler(isDesktop) {
        if (!isDesktop) {
          this.$router.push('/review/add/');
          this.handleClose();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.getTrendingProducts();
    this.getRecentBought();
  },
  methods: {
    handleClose() {
      this.$store.commit('toggleModalGlobalState', { modalName: 'shareExperience' });
    },
    getTrendingProducts() {
      this.$MS_SOCO_PUBLIC_API_URL
        .get(`/v2/products/featured/trending`, {
          params: {
            filter: {
              is_reviewed: true,
              exclude_reviewed_products: true,
            },
            section: 'TrendingProducts',
          },
        })
        .then((response) => {
          if (response.status === 200 && response.data.data) {
            let items = response.data.data;
            items = items
              .map((res) => {
                if (res.default_combination && !('is_wishlist' in res.default_combination)) {
                  res.default_combination.is_wishlist = false;
                }
                res['image'] = get(last(res.images || []), 'url', '');
                res['manufacturer_name'] = get(res, 'brand.name', '');
                res['product_name'] = get(res, 'name', '');
                res['combination_id'] = res.default_combination._id
                  ? res.default_combination._id
                  : res.combinations[0]._id;
                return res;
              })
              .filter((item) => !item.is_reviewed);
            this.$store.commit('setProductTrendingPopup', items);
          } else {
            this.$store.commit('setProductTrendingPopup', []);
          }
        })
        .catch((err) => {
          this.$store.commit('setProductTrendingPopup', []);
        });
    },
    getRecentBought() {
      this.$MS_ORDER_API_URL
        .get('users/me/recently-bought', {
          params: {
            fields: 'id,images,brand,name,default_combination,combinations',
          },
        })
        .then((res) => {
          if (res.status == 200 && res.data.success) {
            const datas = ((res.data && res.data.data) || [])
              .map((item) => {
                item['image'] = get(last(item.images || []), 'url', '');
                item['manufacturer_name'] = get(item, 'brand.name', '');
                item['product_name'] = get(item, 'name', '');
                item['combination_id'] = item.default_combination._id
                  ? item.default_combination._id
                  : item.combinations[0]._id;
                return item;
              })
              .reverse()
              .filter((item) => !item.is_reviewed);
            this.$store.commit('setRecentlyBought', datas);
          } else {
            this.$store.commit('setRecentlyBought', []);
          }
        })
        .catch((err) => {
          this.$store.commit('setRecentlyBought', []);
        });
    },
  },
};
</script>

<style lang="scss">
.modal-dialog {
  width: max-content;
}

.modal-content {
  overflow: hidden;
  margin-top: 20px;
  margin-bottom: 20px;

  .modal-header,
  .modal-body {
    padding: 0 !important;
  }

  .share-experience {
    width: 536px;
    max-height: 638px;

    &.see-all {
      width: 736px;

      .body-wrapper {
        padding: 16px;

        > h5 {
          color: #716a68;

          span {
            font-weight: bold;
          }
        }

        > .product-list-wrapper {
          grid-template-columns: 1fr;
        }
      }
    }

    > .header-banner {
      display: flex;
      font-family: 'Lato', sans-serif;
      flex-direction: column;
      align-items: center;
      padding: 20px 16px 40px;
      background-color: #fff3f3;
      color: #b32656;
      background-image: url('/assets/img/banner-share-experience.svg');
      background-repeat: no-repeat;
      background-size: contain;
      text-align: center;

      > :first-child {
        font-weight: bold;
      }
    }

    > .body-wrapper {
      font-family: 'Lato', sans-serif;
      position: relative;
      padding: 40px 16px 16px;

      > h4 {
        font-weight: bold;
        margin-bottom: 12px;
      }

      > .search-wrapper {
        position: absolute;
        top: -20px;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;

        > .input-search-header {
          width: 70%;
          background-color: white;
        }
      }

      > .product-list-wrapper {
        display: grid;
        grid-template-columns: 1fr;
        gap: 12px;
        max-height: 370px;
        overflow-y: scroll;
        margin-top: 24px;
        padding-bottom: 12px;

        > .card-recently-bought {
          width: 100%;
        }
      }
    }
  }
}
</style>
